export default function verified ({ next, store }){

   if(store.getters.getUser.email_verified_at == null){
      return next('/email/verify')
   } else {
      return next()
   }
}